import {
  INVALID_CARD_EXPIRATION_MONTH,
  INVALID_CARD_EXPIRATION_YEAR,
  INVALID_CARD_EXPIRATION_IN_PAST,
  INVALID_CARD_NUMBER,
  INVALID_POSTAL_CODE,
  INVALID_CARD_TYPE,
  UNSUPPORTED_CREDIT_BRAND,
  MISSING_CARD_NUMBER,
  MISSING_CARD_EXPIRY_DETAILS,
  MISSING_POSTAL_CODE,
  MISSING_CARD_TYPE,
  FAILURE_DEBIT_AUTHORIZATION,
  FAILURE_DEBIT_AVS_CHECK,
  INVALID_DEBIT_DISABLED_FOR_CREDIT,
} from '../../../constants/error-codes';

export default {
  cardType: [
    INVALID_CARD_TYPE,
    MISSING_CARD_TYPE,
  ],
  cardNumber: [
    INVALID_CARD_NUMBER,
    UNSUPPORTED_CREDIT_BRAND,
    MISSING_CARD_NUMBER,
    FAILURE_DEBIT_AUTHORIZATION,
    INVALID_DEBIT_DISABLED_FOR_CREDIT,
  ],
  expirationMonth: [
    INVALID_CARD_EXPIRATION_MONTH,
  ],
  expirationYear: [
    INVALID_CARD_EXPIRATION_YEAR,
    INVALID_CARD_EXPIRATION_IN_PAST,
    MISSING_CARD_EXPIRY_DETAILS,
  ],
  zipCode: [
    INVALID_POSTAL_CODE,
    MISSING_POSTAL_CODE,
    FAILURE_DEBIT_AVS_CHECK,
  ],
};
